/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_OfflineInputs */

const en_us2_planshare_offline = /** @type {(inputs: Planshare_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to see and create codes.`)
};

const pt_br2_planshare_offline = /** @type {(inputs: Planshare_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver e gerar códigos.`)
};

const pt_pt2_planshare_offline = /** @type {(inputs: Planshare_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver e gerar códigos.`)
};

/** @type {(inputs: Planshare_OfflineInputs) => LocalizedString} */
const es_419_planshare_offline = en_us2_planshare_offline;

/** @type {(inputs: Planshare_OfflineInputs) => LocalizedString} */
const fr_fr2_planshare_offline = en_us2_planshare_offline;

/** @type {(inputs: Planshare_OfflineInputs) => LocalizedString} */
const de_de2_planshare_offline = en_us2_planshare_offline;

/** @type {(inputs: Planshare_OfflineInputs) => LocalizedString} */
const it_it2_planshare_offline = en_us2_planshare_offline;

/**
* | output |
* | --- |
* | "Connect to the internet to see and create codes." |
*
* @param {Planshare_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_offline = /** @type {((inputs?: Planshare_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_offline(inputs)
	if (locale === "es-419") return es_419_planshare_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_offline(inputs)
	if (locale === "de-DE") return de_de2_planshare_offline(inputs)
	if (locale === "it-IT") return it_it2_planshare_offline(inputs)
	return en_us2_planshare_offline(inputs)
});
export { planshare_offline as "planshare.offline" }